/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 * This is a backup of the endpoints with ticket urls just in case ... will delete later
 */

// cSpell:ignore ticket, ticket, ratingreview, recarea

import { urlWithParams } from '../utils';

// ---------------------------
// Api Root
// ---------------------------
export const API_ROOT = process.env.API || '';

// ---------------------------
// Facility / Tours
// ---------------------------
export const getFacilityUrl = (facilityId) => `${API_ROOT}/ticket/facility/${facilityId}`;

// temporary until timed entry has content
export const getTicketFacilityUrl = (facilityId) =>
    `${API_ROOT}/ticket/facility/${facilityId}`;

export const getToursByFacilityUrl = (facilityId) =>
    `${API_ROOT}/ticket/facility/${facilityId}/tour`;

// ---------------------------
// Facility availability, times
// ---------------------------
export const getFacilityAvailabilityUrl = ({
    facilityId,
    year,
    month,
    accountType = 'FIT',
}) => {
    const baseUrl = `${API_ROOT}/ticket/availability/facility`;
    return `${baseUrl}/${facilityId}/monthlyAvailabilitySummaryView?year=${year}&month=${month}&inventoryBucket=${accountType}`;
};

export const getTourTimesUrl = ({ facilityId, tourId, reservationId, date }) => {
    const tourPath = tourId ? `/tour/${tourId}` : '';
    const reservationPath = reservationId ? `&reservation_id=${reservationId}` : '';
    const baseUrl = `${process.env.API}/ticket/availability/facility`;
    return `${baseUrl}/${facilityId}${tourPath}?date=${date}${reservationPath}`;
};

// ---------------------------
// Pricing View
// ---------------------------
export const getPricingViewUrl = (facilityId) =>
    `${process.env.API}/ticket/facility/${facilityId}/pricing/view`;

// ---------------------------
// Reservation creation and modification
// ---------------------------
export const getModifyReservationUrl = (reservationId) =>
    `${process.env.API}/ticket/reservation/${reservationId}/savePendingModifications`;

export const getCreateReservationUrl = () => `${process.env.API}/ticket/reservation`;

// ---------------------------
// Order Details
// ---------------------------
export const getOrderDetailsViewUrl = (reservationId) =>
    `${API_ROOT}/ticket/orderDetails?reservationId=${reservationId}`;

// ---------------------------
// PDF
// ---------------------------
export const getPDFUrl = (reservation) => {
    const facilityId = reservation?.order_details?.facility_id ?? '';
    return `${API_ROOT}/ticket/facility/${facilityId}/reservations/${reservation.reservation_id}/tickets/pdf`;
};

export const getLargeGroupPDFUrl = (reservation) => {
    return `${API_ROOT}/ticket/reservations/${reservation.reservation_id}/pdf`;
};

/** ***********************************
 * NON TIMED-ENTRY ENDPOINTS
 * ***********************************/

// ---------------------------
// Facility rating-review
// ---------------------------
export const getFacilityRatingReviewUrl = (facilityId) => {
    const locationType = 'Timed Entry';
    return `${API_ROOT}/ratingreview/aggregate?location_id=${facilityId}&location_type=${encodeURIComponent(
        locationType
    )}`;
};

// ---------------------------
// Tour rating-review
// ---------------------------
export const getTourRatingReviewUrl = (tourId) => {
    const locationType = 'Tour';
    return `${API_ROOT}/ratingreview/aggregate?location_id=${tourId}&location_type=${encodeURIComponent(
        locationType
    )}`;
};

// ---------------------------
// Rec area
// ---------------------------
export const getRecAreaUrl = (id) => {
    const args = {
        fq: ['entity_type:recarea', `entity_id:${id}`],
    };

    const recAreaUrl = urlWithParams(`${process.env.API}/search`, args);
    return recAreaUrl;
};

// ---------------------------
// Media service
// ---------------------------
export const getTourImagesUrl = (tourId) => `/api/media/public/tour/${tourId}`;
export const getFacilityImagesUrl = (facilityId) =>
    `/api/media/public/asset/${facilityId}`;

// ---------------------------
// Gateway / Tours
// ---------------------------
export const getToursByGatewayUrl = (gatewayId) =>
    `${API_ROOT}/ticket/gateway/${gatewayId}/tour`;
